import {
  getAttendancePercentage,
  // getEmpCalendarPunches,
  getEmpPunchLogs,
  getLeaveTaken,
  getPendingException,
  getPendingExpense,
  getPendingOnboarding,
  getPendingPayroll,
  getPendingReimbursement,
  getTopPerformerList,
} from 'services/axios/dashboard'

export const actions = {
  GET_ATTENDANCE_PERCENTAGE: 'GET_ATTENDANCE_PERCENTAGE',
  GET_PENDING_PAYROLL: 'GET_PENDING_PAYROLL',
  GET_PENDING_EXCEPTION: 'GET_PENDING_EXCEPTION',
  GET_PENDING_EXPENSE: 'GET_PENDING_EXPENSE',
  GET_PENDING_REIMBURSEMENT: 'GET_PENDING_REIMBURSEMENT',
  GET_PENDING_ONBOARDING: 'GET_PENDING_ONBOARDING',
  GET_PERFORMER_LIST: 'GET_PERFORMER_LIST',
  GET_LEAVE_TAKEN: 'GET_LEAVE_TAKEN',
  GET_EMP_PUNCH_LOGS: 'GET_EMP_PUNCH_LOGS',
  GET_EMP_CALENDAR_PUNCH_LOGS: 'GET_EMP_CALENDAR_PUNCH_LOGS',
}

export const attendancePercentage = ({ userId }) => {
  return async (dispatch) => {
    const response = await getAttendancePercentage({ userId })
    dispatch({
      type: actions.GET_ATTENDANCE_PERCENTAGE,
      payload: {
        attendancePercentage: response?.data?.data?.attendancePercentage,
      },
    })
  }
}
export const pendingPayroll = ({ userId }) => {
  return async (dispatch) => {
    const response = await getPendingPayroll({ userId })
    dispatch({
      type: actions.GET_PENDING_PAYROLL,
      payload: {
        pendingPayroll: response?.data?.data?.pendingPayroll,
      },
    })
  }
}
export const pendingException = ({ userId }) => {
  return async (dispatch) => {
    const response = await getPendingException({ userId })
    dispatch({
      type: actions.GET_PENDING_EXCEPTION,
      payload: {
        pendingException: response?.data?.data?.pendingException,
      },
    })
  }
}
export const pendingExpense = () => {
  return async (dispatch) => {
    const response = await getPendingExpense()
    dispatch({
      type: actions.GET_PENDING_EXPENSE,
      payload: {
        pendingExpense: response?.data?.data?.pendingExpense,
      },
    })
  }
}

export const pendingReimbursement = ({ userId }) => {
  return async (dispatch) => {
    const response = await getPendingReimbursement({ userId })
    dispatch({
      type: actions.GET_PENDING_REIMBURSEMENT,
      payload: {
        pendingReimbursement: response?.data?.data?.pendingReimbursement,
      },
    })
  }
}
export const pendingOnboarding = () => {
  return async (dispatch) => {
    const response = await getPendingOnboarding()
    dispatch({
      type: actions.GET_PENDING_ONBOARDING,
      payload: {
        pendingOnboarding: response?.data?.data?.pendingOnboarding,
      },
    })
  }
}
export const topPerformerList = () => {
  return async (dispatch) => {
    const response = await getTopPerformerList()
    dispatch({
      type: actions.GET_PERFORMER_LIST,
      payload: {
        topPerformerList: response?.data?.data?.performerList,
      },
    })
  }
}
export const leaveTaken = ({ userId }) => {
  return async (dispatch) => {
    const response = await getLeaveTaken({ userId })
    dispatch({
      type: actions.GET_LEAVE_TAKEN,
      payload: {
        leaveTaken: response?.data?.data?.totalLeaveDays,
      },
    })
  }
}

export const fetchEmpPunchLogs = () => {
  return async (dispatch) => {
    const response = await getEmpPunchLogs()
    dispatch({
      type: actions.GET_EMP_PUNCH_LOGS,
      payload: {
        empPunchLogs: response?.data || [],
      },
    })
  }
}

// export const fetchEmpCalendarPunches = () => {
//   return async (dispatch) => {
//     const response = await getEmpCalendarPunches()
//     dispatch({
//       type: actions.GET_EMP_CALENDAR_PUNCH_LOGS,
//       payload: {
//         empCalPunches: response?.data || [],
//       },
//     })
//   }
// }
